import styled from '@emotion/styled';

export const StyledAsterisk = styled.span`
  float: left;
  margin-right: 4px;
  color: ${props => props.theme.color.red};
`;
